import { render, staticRenderFns } from "./MonsterNavigation.vue?vue&type=template&id=787ce088&lang=pug&"
import script from "./MonsterNavigation.vue?vue&type=script&lang=ts&"
export * from "./MonsterNavigation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports